import React from "react";

import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { FilterOption } from "@/types";

interface FilterBoxProps {
  label: string;
  value: string;
  options: FilterOption[];
  onChange?: (event: SelectChangeEvent) => void;
  onClick?: (option: string) => void;
  startIcon?: React.ReactNode;
  showSelected?: boolean;
  size?: "medium" | "small";
  width?: number;
}

const FilterBox: React.FC<FilterBoxProps> = ({
  label,
  value,
  options,
  onChange,
  onClick,
  startIcon,
  showSelected = false,
  size = "small",
  width = 200,
}) => {
  const theme = useTheme();

  return (
    <Select
      size={size}
      variant="outlined"
      value={value}
      onChange={onChange ?? onChange}
      displayEmpty
      renderValue={(value: string) => (
        <Box display="flex" flexDirection="row" alignItems="center">
          {startIcon && (
            <Box display="flex" mr={0.5}>
              {startIcon}
            </Box>
          )}
          {showSelected && value !== "" ? (
            <Typography color="textPrimary">
              {options.find((option) => option.name === value)?.label}
            </Typography>
          ) : (
            <Typography color="textSecondary">{label}</Typography>
          )}
        </Box>
      )}
      sx={{
        minWidth: {width},
        "& > fieldset": {
          borderColor: value !== "" ? theme.palette.primary.main : "",
        },
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.name}
          value={option.name}
          onClick={() => (onClick ? onClick(option.name) : {})}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default FilterBox;
